<template>
  <div class="page about-page">
    <AppHeader />
    <!-- 右侧浮动快捷导航 -->
    <div
      class="float-tabs"
      :class="{ collapsed: !tabsVisible }"
    >
      <div class="tab-list" :class="{ expanded: showAll }">
        <div
          v-for="(tab, index) in visibleTabs"
          :key="tab.id"
          class="tab-item"
          :class="{ active: activeTab === index }"
          @click="selectTab(index)"
        >
          <span class="tab-label">{{ tab.name }}</span>
        </div>
        <div class="tab-item more-btn" v-if="!showAll && expandedCount > 0" @click.stop="showAll = true">
          <span class="tab-label">更多</span>
        </div>
        <div class="tab-item more-btn" v-if="showAll && expandedCount > 0" @click.stop="showAll = false">
          <span class="tab-label">收起</span>
        </div>
      </div>
      <div class="toggle-btn" @click="tabsVisible = !tabsVisible">
        <span class="toggle-arrow" :class="{ 'is-open': tabsVisible }"></span>
      </div>
    </div>
    <!-- 内容区正常展示 -->
    <div class="content">
      <div class="tab-panel" v-if="activeTabItem">
        <h3 class="panel-title">{{ activeTabItem.name }}</h3>
        <div class="panel-body" v-if="activeTabItem.type =='single'">
          <div class="empty-state" v-if="!activeTabItem.content">暂无内容</div>
          <div v-else v-html="activeTabItem.content"></div>
        </div>
        <AboutArticleList v-else :categoryId="currentCategoryId" />
      </div>
    </div>
  </div>
</template>

<script>
import { getColumnIdByName } from '../utils/common'
import { getContent } from '../api/content'
import AppHeader from './components/AppHeader.vue'
import AboutArticleList from './components/AboutArticleList.vue'

const INITIAL_VISIBLE_COUNT = 4

export default {
  components: {
    AppHeader,
    AboutArticleList,
  },
  data() {
    return {
      activeTab: 0,
      showAll: false,
      tabsVisible: true,
      tabList: [
        { id: 'intro',type: 'single', name: '中心简介', content: '' },
        { id: 'xbdw',type: 'single', name: '协办单位', content: '' },
        { id: 'framework',type: 'list', name: '组织框架', content: '中心下设新闻编辑部、调研采访部、新媒体运营部、对外联络部、综合管理部等部门。各部门配备专业人员，形成了一支业务精湛、作风优良的工作团队。' },
        { id: 'org', type: 'list', name: '组织机构', content: '中心下设新闻编辑部、调研采访部、新媒体运营部、对外联络部、综合管理部等部门。各部门配备专业人员，形成了一支业务精湛、作风优良的工作团队。' },
        { id: 'staff', type: 'list', name: '组织人员', content: '中心现有工作人员120余人，其中高级记者30人，中级记者50人。团队成员具有丰富的环保法治报道经验，多次获得国家级新闻奖项。' },
        { id: 'appointment', type: 'list', name: '任命公示', content: '根据中心发展需要，经理事会研究决定，任命张汉文同志为北京总部技术总监，任期三年。特此公示。公示期为2026年6月1日至6月7日。' },
        { id: 'authorization', type: 'list', name: '授权公示', content: '经中心授权，以下单位具有开展环保法治宣传合作的资格：北京市环境保护宣传中心、上海市生态文明建设促进会、广东省绿色发展协会。授权有效期至2027年12月31日。' },
        { id: 'party', type: 'list', name: '党建工作', content: '中心党支部现有党员45人。党支部坚持以习近平新时代中国特色社会主义思想为指导，深入开展党史学习教育，扎实推进"两学一做"学习教育常态化制度化，充分发挥党组织的战斗堡垒作用和党员的先锋模范作用。' },
        { id: 'notice', type: 'list', name: '对外公告', content: '公告：中心办公地址已迁至国务院45号院（北京复兴门大街），联系电话010-12345678。请各位合作伙伴及来访人员注意变更信息。' },
        { id: 'branches', type: 'list', name: '分支机构', content: '中心在全国设有15个分支机构，覆盖华北、华东、华南、西南、西北等主要区域。各分支机构在当地积极开展环保法治宣传活动，形成了全国性的宣传网络。' },
        { id: 'certification',type: 'list',  name: '车辆认证', content: '中心新闻采访车辆均已通过环保认证，符合国六排放标准。车辆统一喷涂中心标识，配备卫星定位系统和应急通讯设备。' },
        { id: 'video', type: 'list', name: '视频专栏', content: '中心视频专栏定期发布环保法治主题视频，涵盖政策解读、案例分析、专家访谈等内容。欢迎社会各界关注订阅。' },
        { id: 'contact', type: 'single', name: '联系我们', content: '地址：国务院45号院（北京复兴门大街）\n电话：010-12345678\n邮箱：contact@example.com\n微信公众号：环保监察与法治报道' },
        { id: 'join', type: 'list', name: '申请加入', content: '欢迎有志于环保法治宣传事业的人士加入中心。申请者需具备新闻、法律、环境科学等相关专业背景，具有良好的职业道德和团队协作精神。请将简历发送至邮箱：hr@example.com。' },
      ],
    }
  },
  computed: {
    expandedCount() {
      return Math.max(0, this.tabList.length - INITIAL_VISIBLE_COUNT)
    },
    visibleTabs() {
      return this.showAll ? this.tabList : this.tabList.slice(0, INITIAL_VISIBLE_COUNT)
    },
    activeTabItem() {
      return this.tabList[this.activeTab] || null
    },
    currentCategoryId() {
      return getColumnIdByName(this.tabList[this.activeTab].name)
    }
  },
  mounted() {
    this.getSinglePage("中心简介",0)
    document.title = "关于我们 - " + window.__appBasic ? window.__appBasic.appName:'生态保护与法治报道中心'
  },
  methods: {
    selectTab(index) {
      this.activeTab = index
      let type = this.tabList[index].type 
      if (type == 'single') this.getSinglePage(this.tabList[index].name,index)
    },
    async getSinglePage(name,index) {
      this.loading = true
      const data = await getContent({ id: getColumnIdByName(name) })
      this.tabList[index].content = data.content
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.about-page {
  background-color: #f5f5f5;
  min-height: 100vh;
  position: relative;
}

/* 右侧浮动快捷导航 */
.float-tabs {
  position: fixed;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.collapsed {
    pointer-events: none;

    .tab-list {
      opacity: 0;
      transform: scale(0.8) translateX(30px);
      pointer-events: none;
    }

    .toggle-btn {
      pointer-events: auto;
      background: #fff;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }
  }
}

.tab-list {
  width: 72px;
  height: 230px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(4, 100, 202, 0.12);
  padding: 10px 6px;
  transition: all 0.3s ease;
  transform-origin: right center;
}

.toggle-btn {
  margin-top: 10px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
}

.toggle-arrow {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 6px solid #0464CA;
  transition: transform 0.3s ease;

  &.is-open {
    transform: rotate(180deg);
  }
}

.tab-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 8px;
  margin-bottom: 6px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s;

  &:last-child {
    margin-bottom: 0;
  }

  &:hover {
    background: #f5f8ff;
  }

  &.active {
    background: linear-gradient(135deg, #0464CA 0%, #1a7ee6 100%);
    box-shadow: 0 4px 10px rgba(4, 100, 202, 0.28);

    .tab-label {
      color: #fff;
      font-weight: 600;
    }
  }
}

.tab-label {
  font-size: 11px;
  color: #555;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
}

.more-btn {
  .tab-label {
    color: #999;
  }

  &:hover {
    background: #f8f8f8;
  }
}

/* 内容区 */
.content {
  padding: 12px 16px;
}

.panel-title {
  font-size: 16px;
  font-weight: 700;
  color: #0464CA;
  margin: 0 0 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(4, 100, 202, 0.15);
}

.panel-body {
  font-size: 14px;
  color: #444;
  line-height: 1.8;
  background-color: #fff;
  padding: 10px;;
  p {
    margin: 0 0 10px;
    text-indent: 2em;
  }
}
</style>
